import { useCallback } from 'react';
import { navigate, PATHS } from '@client/routes';
import auth from '@client/components/auth';
import { AuthorId } from '../model/post.types';
import { analytics } from './analytics';
import { resolveInfluencerId } from './resolveInfluencerId';
import { useCommunityContext } from './communityContext';

export const useReplyInDm = (authorId: AuthorId) => {
  const { influencerId } = useCommunityContext();

  return useCallback(() => {
    analytics.trackRepliedViaDm();
    if (auth.isInfluencer()) {
      navigate(PATHS.INBOX(authorId));
      return;
    }
    const creatorId = resolveInfluencerId(influencerId);
    if (creatorId !== null) {
      navigate(PATHS.INBOX_MESSAGE(creatorId, authorId));
    }
  }, [authorId, influencerId]);
};
